// api
import { fetchApi } from '@/api'
// actions
const inventoryProductsSubCategoriesAll = (context) => {
  let url = 'inventory/products/subcategories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubCategoriesForm = (context) => {
  let url = 'inventory/products/subcategories/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubCategoriesResta = (context) => {
  let url = 'inventory/products/subcategories/CrearSUB'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}


const inventoryProductsSubCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/subcategories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/subcategories'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubcategories = (context, payloadId) => {
  let obj = JSON.parse(payloadId)
  let url = 'inventory/products/categories/' + payloadId + '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsSubcategoriesAll = (context, payload) => {

  let url = 'inventory/products/categories/' + payload.id + '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsFilterSubCategories = (context, payloadId) => {
  let url = 'inventory/products/subcategories/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_FILTER_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsFilterSubCategoriesAll = (context, payload) => {

  let url = 'inventory/products/subcategories/' + payload.id + '/products'
  let data = JSON.stringify(payload)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_FILTER_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  inventoryProductsSubCategoriesAll,
  inventoryProductsSubCategoriesForm,
  inventoryProductsSubCategoriesShow,
  inventoryProductsSubCategoriesCreate,
  inventoryProductsSubCategoriesUpdate,
  inventoryProductsSubCategoriesDelete,
  inventoryProductsSubcategories,
  inventoryProductsSubcategoriesAll,
  inventoryProductsFilterSubCategories,
  inventoryProductsFilterSubCategoriesAll,
  inventoryProductsSubCategoriesResta
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/subcategories/actions.js